import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import {
  Button, TextField, InputAdornment, Radio, RadioGroup, FormControlLabel, FormControl,
  InputLabel, Select, MenuItem
} from '@material-ui/core';

import { changeSettings, decodeHTMLEntities } from '../../../Functions/utils';
import { useAppContext } from '../../../Context/App/Provider';
import { setContactEmail, updateSettings } from '../../../Functions/user';

import { values, colors, toastTimerValue, roles } from '../../../Shared/utils';
// import { roles } from '../../../../Shared/utils';

import './Settings.css';
import ChangePassword from './ChangePassword';
import ChangeUsername from './ChangeUsername';
import { red } from '@material-ui/core/colors';

import '../../SweetAlert.css'

export default function Settings() {
  const { t } = useTranslation();

  const [resetPw, setResetPw] = useState(false);
  const [changeUsername, setChangeUsername] = useState(false);

  const [{settings, user}, appDispatch] = useAppContext();


  const resetEmail = async () => {
    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('settings.email.reset'),
      showCancelButton: true,
      confirmButtonText: t("global.yes"),
      cancelButtonText: t("global.no"),
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
        }
    }).then(async (value) => {
      // console.log("83 - value=", value);

      if (value && value.isConfirmed) {
      const res = await setContactEmail(user.id, null);

        if (!res.success) {
          return toast(decodeHTMLEntities(t('email.errors.email.' + res)), { type: 'error' });
        }

      sessionStorage.removeItem('emailPrompted');
      return window.location.pathname = '/settings';
    }
    });
  };

  const resetDefaultSettings = () => {
    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('settings.reset.reset'),
      showCancelButton: true,
      confirmButtonText: t("global.yes"),
      cancelButtonText: t("global.no"),
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
      },
      closeOnClickOutside: false
    }).then((value) => {
      // console.log("149 - value=", value);

      if (value && value.isConfirmed) {
      updateSettings(null).then(res => {
          if (!res.success) {
            return toast(decodeHTMLEntities(t('settings.error.reset')), { type: 'error' });
          }

        localStorage.clear(); // stay signed in
        localStorage.setItem('signedIn', true);
        window.location.pathname = '/settings';
      });
    }
    });
  };


  useEffect(() => {
    document.title = t('settings.page');
  }, [t]);

  // console.log("52 - settings=", settings);
  // console.log("53 - user=", user);

  if (user.roleId <= roles.stAdmin) {
    
    if (settings.activityDecreasedDays >= 7 && settings.activityDecreasedPrevious === 'week') {
      //setActivityDecreasedPrevious("month")
      changeSettings(t, 'activityDecreasedPrevious', 'month', settings, appDispatch)
    }
    else if (settings.activityDecreasedDays >= 30 && (settings.activityDecreasedPrevious === 'week' || settings.activityDecreasedPrevious === 'month')) {
      // setActivityDecreasedPrevious("year")
      changeSettings(t, 'activityDecreasedPrevious', 'year', settings, appDispatch)
    }
  }


  // console.log("114 - user.locations=", user && user.locations);
  let showNoFavoriteLocation = user.roleId <= roles.stAdmin;
  if (showNoFavoriteLocation && user && user.locations) {
    let i = 0;
    while (showNoFavoriteLocation && i < user.locations.length) {

      const location = user.locations[i];
      if (location.label && location.favoriteId && location.enabled && location.status === "production") {
        showNoFavoriteLocation = false;
      }
      i++;
    }
    // console.log("123 - showNoFavoriteLocation=", showNoFavoriteLocation);
  }

  // console.log("131 - settings=", settings, settings.licenseOneDayGraceExpirationCheck, user);

  let demoMode = false;
  if (user.email.includes('DEMO_USER_$'))     //userName = "Demo user";
    demoMode = true;

  // console.log("137 - demoMode=", demoMode);

  return (
    <div className="settings">
      <div className="MuiDataGrid-root" role="grid" aria-colcount={0} aria-rowcount={0}>
        <div>
          <div className="content__header">
            <h2>{t('settings.title')}</h2>
          </div>
        </div>

        <div className="MuiDataGrid-main">

          <div className="category" style={{ display: 'flex' }}>

            <div style={{ width: "25%" }}>
            <p className="sidebar__label">{t('settings.username.change')}</p>
            <TextField
              InputProps={{
                readOnly: true,
                endAdornment: <InputAdornment position='start'>
                  <span
                    title={t('global.update')}
                    style={{cursor: 'pointer'}}
                      onClick={() => demoMode ? console.log("demoMode") : setChangeUsername(true)}
                    className="material-icons-round"
                  >edit</span>
                </InputAdornment>
              }}
              variant="outlined"
                title={demoMode ? "Demo user" : user.email}
                defaultValue={demoMode ? "Demo user" : user.email}
                value={demoMode ? "Demo user" : user.email}
              className="singleSelect settingsBtn settingsInput"
            />
          </div>
            <div style={{ width: '25%' }}>
            <p className="sidebar__label">{t('settings.password.label')}</p>
            <TextField
              InputProps={{
                readOnly: true,
                endAdornment: <InputAdornment position='start'>
                  <span
                    title={t('global.update')}
                    style={{cursor: 'pointer'}}
                      onClick={() => demoMode ? console.log("demoMode") : setResetPw(true)}
                    className="material-icons-round"
                  >edit</span>
                </InputAdornment>
              }}
              variant="outlined"
              defaultValue="••••••••••••••••"
              className="singleSelect settingsBtn settingsInput"
            />
          </div>

            <div style={{ width: '25%' }}>
            <p className="sidebar__label">{t('settings.email.label')}</p>
            {user.contactEmail ? (
              <TextField
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position='start'>
                    <span
                        onClick={() => demoMode ? console.log("demoMode") : resetEmail()}
                      title={t('global.update')}
                      style={{cursor: 'pointer'}}
                      className="material-icons-round"
                    >edit</span>
                  </InputAdornment>
                }}
                variant="outlined"
                title={user.contactEmail}
                defaultValue={user.contactEmail}
                className="singleSelect settingsBtn settingsInput"
              />
            ) : (
              <Button
                className="singleSelect settingsBtn"
                onClick={() => {
                    if (demoMode)
                      console.log("demoMode");
                    else {
                  sessionStorage.removeItem('emailPrompted');
                  window.location.pathname = '/settings';
                    }
                }}
              >{t('settings.email.button')}</Button>
            )}
          </div>

            <div style={{ width: '25%' }}>
              <p className="sidebar__label">{t('settings.lang')}</p>
              <select
                title="Language"
                className="singleSelect"
                defaultValue={settings.lang || 'en'}
                onChange={e => changeSettings(t, 'lang', e.target.value, settings, appDispatch)}
              >
                {values.languages.map(lang => (
                  <option key={lang.code} value={lang.code}>{lang.name}</option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <br />
          </div>

          <div className="category" style={{ display: 'flex' }}>
            <div style={{ width: "60%" }}>
              <p className="sidebar__label">{t('settings.export.label')}</p>
              <RadioGroup
                row
                // aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="interpreted"
                value={settings.reportingExcelReport}
                onChange={e => {
                  // console.log("100 - e=", e);
                  changeSettings(t, 'reportingExcelReport', e.target.value, settings, appDispatch)
                }}
              >
                <FormControlLabel
                  value="interpreted"
                  control={
                    <Radio
                      style={{
                        color: colors.softthinks
                      }} />
                  }
                  label={t('settings.export.interpreted')}
                />

                <FormControlLabel
                  value="raw"
                  control={
                    <Radio
                      style={{
                        color: colors.softthinks
                      }}
                    />
                  }
                  label={t('settings.export.raw')}
                />
              </RadioGroup>
            </div>

            <div style={{ width: "30%" }}>
              <p className="sidebar__label">{t('settings.report.label')}</p>
              <div className="checkbox action">
                <input
                  id="reportsInArchive"
                  type="checkbox"
                  defaultChecked={settings.reportsInArchive && settings.reportsInArchive !== undefined}
                  onChange={() =>
                    changeSettings(t, 'reportsInArchive', settings.reportsInArchive !== undefined ? !settings.reportsInArchive : true, settings, appDispatch)
                  }
                />
                <label>{t('settings.report.archive')}</label>
              </div>
            </div>
          </div>

          <div style={{ width: '20%' }}>
          <p className="sidebar__label">{t('settings.export.orientation')}</p>
            <select
              title="Orientation"
              className="singleSelect"
              defaultValue={settings.orientation || 'en'}
              onChange={e => changeSettings(t, 'orientation', e.target.value, settings, appDispatch)}
            >
              {values.orientations.map(orient => (
                <option key={orient.code} value={orient.code}>{t('settings.export.'+ orient.name)}</option>
              ))}
            </select>
          </div>

          <div>
            <br />
            <br />
          </div>

          {user.roleId <= roles.stAdmin && (
            <div className="category">
              <p className="sidebar__label">{t('settings.activity_notifications.unexpected_activity')}</p>

              <div className="checkbox action">
                <input
                  id="unexpectedActivity"
                  type="checkbox"
                  defaultChecked={settings.unexpectedActivityCheck}
                  onChange={() =>
                    changeSettings(t, 'unexpectedActivityCheck', !settings.unexpectedActivityCheck, settings, appDispatch)
                  }
                />
                <label>{t('settings.activity_notifications.send_me')}</label>
              </div>

              {settings.unexpectedActivityCheck && (
                <div>
                  <div className="checkbox action">
                    &nbsp;&nbsp;&nbsp;
                    <input
                      style={{ width: '2%' }}
                      disabled={false}
                      id="noActivityDetected"
                      type="checkbox"
                      defaultChecked={settings.noActivityDetected || false}
                      onChange={e =>
                        changeSettings(t, 'noActivityDetected', !settings.noActivityDetected, settings, appDispatch)
                      }
                    />
                    <label style={{ width: '25%' }} htmlFor={t('settings.activity_notifications.no_activity_1')}>
                      {t('settings.activity_notifications.no_activity_1')}
                    </label>

                    <TextField
                      style={{ width: '10%' }}
                      variant='outlined'
                      type="number"
                      // disabled={!isValue}
                      value={settings.noActivityDetectedDays || 1}
                      InputProps={{ inputProps: { min: 1, max: 100 } }}
                      onChange={e => {
                        // console.log("384 - e.target.value=", e.target.value);
                        changeSettings(t, 'noActivityDetectedDays', e.target.value, settings, appDispatch)
                      }}
                      placeholder={t('scenarios.conditions.value')}
                    />
                    <label style={{ width: '10%' }}>
                      {t('settings.activity_notifications.no_activity_2')}
                    </label>

                    {showNoFavoriteLocation && (
                      <div style={{
                        width: '50%', textAlign: "Center",
                        fontSize: '18px', fontWeight: '400', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                        color: '#ff0000', verticalAlign: 'text-bottom'
                      }}>
                        <span
                          className="material-icons"
                          style={{ color: '#ff0000', verticalAlign: 'text-bottom' }}
                        >
                          warning_amber
                          &nbsp;
                        </span>
                        {t('settings.activity_notifications.no_favorite_location')}
                      </div>
                    )}
                  </div>

                  {/* <br /> */}

                  <div className="checkbox action">
                    &nbsp;&nbsp;&nbsp;
                    <input
                      style={{ width: '2%' }}
                      disabled={false}
                      id="activityDecreased"
                      type="checkbox"
                      defaultChecked={settings.activityDecreased || false}
                      onChange={e =>
                        changeSettings(t, 'activityDecreased', !settings.activityDecreased, settings, appDispatch)
                      }
                    />
                    <label style={{ width: '25%' }} htmlFor={t('settings.activity_notifications.activity decreased_1')}>
                      {t('settings.activity_notifications.activity decreased_1')}
                    </label>

                    <TextField
                      style={{ width: '10%' }}
                      variant='outlined'
                      type="number"
                      value={settings.activityDecreasedDays || 1}
                      InputProps={{ inputProps: { min: 1, max: 100 } }}
                      onChange={e => {
                        changeSettings(t, 'activityDecreasedDays', e.target.value, settings, appDispatch)
                      }}
                    //placeholder={t('scenarios.conditions.value')}
                    />

                    <label style={{ width: '10%' }}>{t('settings.activity_notifications.activity decreased_2')}</label>

                    {/* min to 1 and max to 100 */}
                    <TextField
                      style={{ width: '10%' }}
                      variant='outlined'
                      type="number"
                      value={settings.activityDecreasedPercent || 20}
                      InputProps={{ inputProps: { min: 1, max: 100 } }}
                      onChange={e => {
                        // console.log("384 - e.target.value=", e.target.value);
                        changeSettings(t, 'activityDecreasedPercent', e.target.value, settings, appDispatch)
                      }}
                      placeholder={t('scenarios.conditions.value')}
                    />

                    <label >{t('settings.activity_notifications.activity decreased_3')}</label>

                    <FormControl
                      style={{ width: '10%' }}
                      variant="outlined"
                    >
                      <InputLabel>{t('settings.activity_notifications.period')}</InputLabel>
                      <Select
                        value={settings.activityDecreasedPrevious || 'week'}
                        label={t('admin.locations.columns.status')}
                        onChange={e =>
                          changeSettings(t, 'activityDecreasedPrevious', e.target.value, settings, appDispatch)
                        }
                      >
                        {(settings.activityDecreasedDays === undefined || settings.activityDecreasedDays < 7) && (
                          <MenuItem value={'week'}>{t('settings.activity_notifications.week')}</MenuItem>
                        )}
                        {(settings.activityDecreasedDays === undefined || settings.activityDecreasedDays < 30) && (
                          <MenuItem value={'month'}>{t('settings.activity_notifications.month')}</MenuItem>
                        )}
                        <MenuItem value={'year'}>{t('settings.activity_notifications.year')}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              )}
            </div>
          )}

          <div>
            <br />
          </div>

          {user.roleId <= roles.stAdmin && (
            <div className="category">
              <p className="sidebar__label">{t('settings.licenses_notifications.licenses_notifications')}</p>

              <div className="checkbox action">
                <input
                  id="licenseNotChecked"
                  type="checkbox"
                  defaultChecked={settings.licenseNotCheckedCheck !== undefined && settings.licenseNotCheckedCheck}
                  onChange={() =>
                    changeSettings(t, 'licenseNotCheckedCheck', !settings.licenseNotCheckedCheck, settings, appDispatch)
                  }
                />
                <label>{t('settings.licenses_notifications.license_not_checked')}</label>
              </div>

              <br />

              <div className="checkbox action">
                <input
                  id="licenseOneDayGraceExpirationChecked"
                  type="checkbox"
                  defaultChecked={settings.licenseOneDayGraceExpirationCheck !== undefined && settings.licenseOneDayGraceExpirationCheck}
                  onChange={() =>
                    changeSettings(t, 'licenseOneDayGraceExpirationCheck', !settings.licenseOneDayGraceExpirationCheck, settings, appDispatch)
                  }
                />
                <label>{t('settings.licenses_notifications.license_one_day_grace_expiration')}</label>
              </div>
            </div>
          )}

          <div>
            <br />
          </div>

          <div className="category">
            <p className="sidebar__label">{t('settings.auto_load.load_at_start')}</p>

            <div className="checkbox action">
              <input
                id="autoLoadAtStart"
                type="checkbox"
                defaultChecked={settings.autoLoadAtStartCheck || (settings.autoLoadAtStartCheck === undefined)}
                onChange={() =>
                  changeSettings(t, 'autoLoadAtStartCheck', settings.autoLoadAtStartCheck === undefined ? false : !settings.autoLoadAtStartCheck, settings, appDispatch)
                }
              />
              <label>{t('settings.auto_load.load_at_start_txt')}</label>
            </div>
          </div>


          <div className="category">
            <p className="sidebar__label">{t('settings.reset.label')}</p>
            <Button
              //disabled={demoMode}
              onClick={() => demoMode ? console.log("demoMode") : resetDefaultSettings()}
              className="singleSelect settingsBtn"
            >{t('settings.reset.button')}</Button>
          </div>
        </div>
      </div>

      {resetPw && <ChangePassword setResetPw={setResetPw}/>}
      {changeUsername && <ChangeUsername setChangeUsername={setChangeUsername}/>}
    </div>
  );
}
